import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useMortgage() {
    const api = useApi();
    const state = useAppState();
    function getMortgageInfo(onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages", (result) => {
            state.mortgageInfo = result;
            if (onSuccess)
                onSuccess();
        }, !refreshCache, refreshCache);
    }
    function getMortgage(policyId, onSuccess = null, refreshCache = false) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages/" + policyId, (result) => {
            state.policy = result;
            if (onSuccess)
                onSuccess(result);
        }, !refreshCache, refreshCache);
    }
    function addMortgageAccount(mortgage, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages", mortgage)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => addMortgageAccount(mortgage, onSuccess));
            }
        });
    }
    function updateMortgageAccount(mortgage, onSuccess = null) {
        getHttpInstance().put(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages/" + mortgage.id, mortgage)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => updateMortgageAccount(mortgage, onSuccess));
            }
        });
    }
    function deleteMortgageAccount(id, onSuccess = null) {
        getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CreditAccounts/Mortgages/" + id)
            .then((response) => { if (onSuccess)
            onSuccess(response.data); })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => deleteMortgageAccount(id, onSuccess));
            }
        });
    }
    function getInterestRateType(interestRateType) {
        if (interestRateType == null)
            return null;
        if (interestRateType == 0)
            return 'Fixed';
        if (interestRateType == 1)
            return 'Standard Variable';
        if (interestRateType == 2)
            return 'Discounted Tracker';
        return 'Unknown';
    }
    function calculateMonthsRemaining(endDate) {
        const now = new Date();
        const end = new Date(endDate);
        const years = end.getFullYear() - now.getFullYear();
        const months = end.getMonth() - now.getMonth();
        return years * 12 + months;
    }
    function calculateDateProgressPercentage(start, end) {
        const now = new Date();
        const startDate = new Date(start);
        const endDate = new Date(end);
        const total = endDate.getTime() - startDate.getTime();
        const elapsed = now.getTime() - startDate.getTime();
        return Math.round((elapsed / total) * 100);
    }
    return {
        getMortgageInfo,
        getMortgage,
        addMortgageAccount,
        updateMortgageAccount,
        deleteMortgageAccount,
        getInterestRateType,
        calculateMonthsRemaining,
        calculateDateProgressPercentage,
    };
}
